import * as breakpoints from '@js/util/breakpoints'

export default Alpine => {
  let breakpointsData = Alpine.reactive(
    Object.fromEntries(
      Object.keys(breakpoints.sizes).map(name => [name, breakpoints.doesMatch(name)]),
    ),
  )

  for (let name of Object.keys(breakpoints.sizes)) {
    breakpoints.watch(name, matches => {
      breakpointsData[name] = matches
    })
  }

  Alpine.magic('breakpoints', () => {
    return name => breakpointsData[name]
  })
}
